import { useDesignSystem } from 'contexts/design-system'
import CursorPaginationEui from './cursorPagination.eui'
import CursorPaginationMui from './cursorPagination.mui'
import { CursorPaginationProps } from './types'

export type { CursorPaginationProps } from './types'

export default function CursorPagination( props: CursorPaginationProps ) {
	return useDesignSystem() === 'mui'
		? <CursorPaginationMui {...props} />
		: <CursorPaginationEui {...props} />
}
